
import {
  HttpClient, HttpParams
} from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { Provincia } from '../models/provincia.model';

@Injectable()
export class ProvinciaService extends HttpClientBaseService implements IServiceBase<Provincia> {
  constructor(_http: HttpClient) {
    super(_http, 'Provincias/','', false);
  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<Provincia>> {
    throw new Error('Method not implemented.');
  }

  public getAllModels(): Observable<Provincia[]> {
    return super.getAll<Provincia[]>();
  }

  public getModel(): Observable<Provincia> {
    return super.getSingle<Provincia>('');
  }

}
